export default "__VITE_ASSET__fZ0V91Da__"